import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import './NavMenu.css';
import {
    List, AppBar, Toolbar, Button, Link, ListItem, ListItemText,
    Typography, makeStyles, IconButton, Container, Box, Menu, MenuItem
} from '@material-ui/core';
import { AccountCircle } from '@material-ui/icons';
import { useMsal } from "@azure/msal-react";
import { useIsUserInRoles } from '../hooks/useIsUserInRoles';
import { useActiveUser } from '../hooks/useActiveUser';
import logo_1 from '../images/64.png';

/** CSS-in-JS. See https://styled-components.com */
const useStyles = makeStyles({
    root: {
        flexGrow: 1
    },
    navDisplayFlex: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    navbarDisplayFlex: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    listItemRoot: {
        whiteSpace: 'nowrap'
    }
})

const NavMenu = () => {

    // list of routes * names
    const routesNames = []
    const isUsersMenuVisible = useIsUserInRoles(['GlobalAdmin', 'GlobalMember', 'OrganizationAdmin'])
    if (isUsersMenuVisible)
        routesNames.push(["/users", 'Users'])

    routesNames.push(
        ["/organizations", 'Organizations'],
        ["/sites", 'Sites'],
        ["/modems", 'Modems'],
        ["/transporter", 'Transporter'],
    )

    const { instance } = useMsal();
    const activeUser = useActiveUser()
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    // this useStyles hook only works in React functions, not classes
    const classes = useStyles()

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSignOut = () => {
        handleClose();
        instance.logoutRedirect();
    }

    return (
        <header className={classes.root}>
            <Box mb={2}>
                <AppBar position='static'>
                    <Toolbar variant='dense'>
                        <Container className={classes.navbarDisplayFlex} maxWidth='xl'>
                            <Box display='flex' flexDirection='row' alignItems='center'>
                                <Link component={RouterLink} to="/" >
                                    <img src={logo_1} />
                                </Link>
                                <Typography variant='h6'>
                                    &nbsp;&nbsp;CL<b>AIR</b>ITY&trade; Link
                                </Typography>
                            </Box>

                            <List component='nav' className={classes.navDisplayFlex}>
                                {routesNames.map(([link, title]) => (
                                    <ListItem key={link}>
                                        <Button component={RouterLink} to={link}>
                                            <ListItemText className={classes.listItemRoot} primary={title} color='onPrimary' />
                                        </Button>
                                    </ListItem>)
                                )}
                                <IconButton onClick={handleMenu} color='default'>
                                    <AccountCircle fontSize='large' />
                                </IconButton>
                            </List>
                            <Menu id='menu-profile'
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={open}
                                onClose={handleClose}
                            >
                                <MenuItem>
                                    <Link component={RouterLink} to={'/users/' + instance.getActiveAccount()!.localAccountId}>
                                        {activeUser?.displayName ?? 'User Invalid'}
                                    </Link>
                                </MenuItem>
                                <MenuItem onClick={handleSignOut}>Sign Out</MenuItem>
                            </Menu>
                        </Container>
                    </Toolbar>
                </AppBar>
            </Box>
        </header>
    )
}

export default NavMenu